import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ASSET_TEMPLATE } = API_ROUTES;

class AssetTemplateService {
  createAssetTemplate = (params: unknown) =>
    sendCall(ASSET_TEMPLATE.POST, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  getAssetTemplate = (page: number | null, pagination: boolean) =>
    sendCall(`${ASSET_TEMPLATE.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  editAssetTemplate = (id: string | undefined, params: unknown) =>
    sendCall(`${ASSET_TEMPLATE.EDIT}/${id}`, { data: params, method: HTTP_METHODS.POST });

  disableAssetTemplate = (id: string | undefined) =>
    sendCall(`${ASSET_TEMPLATE.DISABLE}/${id}`, { method: HTTP_METHODS.POST });

  searchAssetTemplate = (params: unknown, page: number) =>
    sendCall(`${ASSET_TEMPLATE.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new AssetTemplateService();
